var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNormalNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#323232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5L9 10.5V19.5C9 24.4711 13.0289 28.5 18 28.5C22.9711 28.5 27 24.4711 27 19.5V10.5L18 7.5ZM25.3125 19.5C25.3125 23.5383 22.0383 26.8125 18 26.8125C13.9617 26.8125 10.6875 23.5383 10.6875 19.5V11.7656L18 9.1875L25.3125 11.7656V19.5Z",
    fill: "#3491FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8686 17.1342C14.7904 17.0556 14.6974 16.9933 14.5951 16.9507C14.4927 16.9082 14.3829 16.8863 14.2721 16.8863C14.1612 16.8863 14.0515 16.9082 13.9491 16.9507C13.8468 16.9933 13.7538 17.0556 13.6756 17.1342C13.597 17.2124 13.5347 17.3053 13.4922 17.4077C13.4496 17.5101 13.4277 17.6198 13.4277 17.7307C13.4277 17.8415 13.4496 17.9513 13.4922 18.0536C13.5347 18.156 13.597 18.2489 13.6756 18.3271L16.7084 21.36L16.7576 21.4092C16.8316 21.4833 16.9195 21.5421 17.0162 21.5822C17.1129 21.6223 17.2166 21.643 17.3213 21.643C17.426 21.643 17.5297 21.6223 17.6264 21.5822C17.7231 21.5421 17.811 21.4833 17.885 21.4092L23.1233 16.1709C23.1974 16.0969 23.2562 16.0091 23.2963 15.9123C23.3364 15.8156 23.357 15.7119 23.357 15.6072C23.357 15.5025 23.3364 15.3988 23.2963 15.3021C23.2562 15.2054 23.1974 15.1175 23.1233 15.0436L23.0576 14.9779C22.9837 14.9038 22.8958 14.845 22.7991 14.8049C22.7024 14.7648 22.5987 14.7441 22.494 14.7441C22.3893 14.7441 22.2856 14.7648 22.1888 14.8049C22.0921 14.845 22.0043 14.9038 21.9303 14.9779L17.3201 19.5857L14.8686 17.1342Z",
    fill: "#3491FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#3491FA",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalNews);
export default __webpack_public_path__ + "static/media/normal-news.aa4a5e5e3b980569b93535664c9c3b62.svg";
export { ForwardRef as ReactComponent };